<template>
  <v-chip
    size="small"
    v-if="display.width.value >= 450"
    label
    :color="statusColor"
    :text="statusText"
  />
  <v-icon v-tooltip="{ openOnClick: true, text: statusText }" v-else :color="statusColor"
    >mdi-information-variant-box</v-icon
  >
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES
import Colors from '@/styles/_colors.module.scss'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useDisplay, type DisplayInstance } from 'vuetify'

const display: DisplayInstance = useDisplay()
const { t } = useI18n({ useScope: 'global' })

// PROPS & EMITS
const props = defineProps({
  isSandbox: { type: Boolean, default: false }
})

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const statusColor = computed(() => {
  return props.isSandbox ? Colors.accentSandbox : Colors.accentProduction
})

const statusText = computed(() => {
  return props.isSandbox ? t('labels.sandbox') : t('labels.production')
})

// LIFECYCLE HOOKS

// FUNCTIONS
</script>
